import * as React from 'react';
import { Image, DecorativeImage, LazyImage, DecorativeLazyImage, } from '../image';
import { getCommonProps } from '../helpers/common-props';
const isSourceElement = (child) => {
    return child.type === 'source';
};
const isImageComponent = (child) => {
    return child.type === Image;
};
const isDecorativeImageComponent = (child) => {
    return child.type === DecorativeImage;
};
export const LazyPicture = React.forwardRef((props, ref) => {
    const { children } = props;
    const commonProps = getCommonProps(props);
    const newChildren = children.map((child) => {
        if (isSourceElement(child)) {
            return (React.createElement("source", Object.assign({}, child.props, { key: child.key, contentEditable: undefined, srcSet: undefined, "data-srcset": child.props.srcSet })));
        }
        if (isImageComponent(child)) {
            return (React.createElement(LazyImage, Object.assign({}, child.props, { key: child.key, src: undefined, srcSet: undefined, "data-src": child.props.src, "data-srcset": child.props.srcSet, _disableNoScript: true })));
        }
        if (isDecorativeImageComponent(child)) {
            return (React.createElement(DecorativeLazyImage, Object.assign({}, child.props, { key: child.key, src: undefined, srcSet: undefined, "data-src": child.props.src, "data-srcset": child.props.srcSet, _disableNoScript: true })));
        }
        return undefined;
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("noscript", null,
            React.createElement("picture", null, children)),
        React.createElement("picture", Object.assign({ ref: ref }, commonProps), newChildren)));
});
LazyPicture.displayName = 'Picture';
